import { getWindow } from '../general';
export var openNativeAppLabel = function (htmlLabel) {
    var _a, _b;
    var base64Html = btoa(htmlLabel);
    (_b = (_a = getWindow()) === null || _a === void 0 ? void 0 : _a.LIFE_CYCLE_EVENT_BUS) === null || _b === void 0 ? void 0 : _b.trigger('NATIVE_APP.PRINT_BASE64', {
        base64HtmlData: base64Html,
    });
};
export var openNewWindow = function () {
    var newWindow = window.open('', '_blank', 'top=0,left=0,height=750px,width=auto,scrollbars=yes,resizable=yes');
    return newWindow;
};
export var createHtmlContent = function (returnLabels, orderId) {
    var base64decode = 'data:image/png;base64,';
    var conversionSrcArray = returnLabels.map(function (label) {
        var graphicLabelImage = (label === null || label === void 0 ? void 0 : label.labelGraphicImage) || (label === null || label === void 0 ? void 0 : label.LabelGraphicImage);
        return base64decode + graphicLabelImage;
    });
    return "\n  <!DOCTYPE html PUBLIC>\n  <html>\n    <head>\n      <title>Return Label | Order #".concat(orderId, "</title>\n      <style>\n      @page {\n        size: landscape;\n      }\n      </style>\n    </head>\n    <body style='text-align:center'>\n      <div id='imgDiv' style='display:block'>\n        ").concat(conversionSrcArray
        .map(function (conversionSrc, index) {
        return "<img src='".concat(conversionSrc, "' alt='Label ").concat(index + 1, "' /><br />").concat(index !== conversionSrcArray.length - 1
            ? '<div style="page-break-after: always;"></div>'
            : '');
    })
        .join(''), "\n      </div>\n      <script>\n        const printLabel = () => {\n          window.print();\n        };\n\n        // Print the labels after a delay to allow the images to load\n        setTimeout(printLabel, 1000);\n      </script>\n    </body>\n  </html>\n");
};
export var getErrorBySSRCode = function (error) {
    switch (error.code) {
        case 'SSR_UPSPRNTLBL_ERR_1003':
            // Non UPS Tracking Number Error
            return {
                type: 'TEMPORARY',
                retryable: error.retryable,
            };
        case 'SSR_UPSPRNTLBL_ERR_1012':
            // Label Not Found Error
            return {
                type: 'TRYAGAIN',
                retryable: error.retryable,
            };
        case 'SSR_UPSPRNTLBL_ERR_1013':
            // Not Printable Error. Same case as Switched to Pickup
            return {
                type: 'SWITCHEDTOPICKUP',
                retryable: error.retryable,
            };
        case 'SSR_UPSPRNTLBL_ERR_1014':
            // Label Reuse Error
            return {
                type: 'USED',
                retryable: error.retryable,
            };
        case 'SSR_UPSPRNTLBL_ERR_1015':
            // Expired Label Error
            return {
                type: 'EXPIRED',
                retryable: error.retryable,
            };
        case 'SSR_UPSPRNTLBL_ERR_1016':
            // Invalid Label Error (switched from dropoff to pickup)
            return {
                type: 'SWITCHEDTOPICKUP',
                retryable: error.retryable,
            };
        case 'SSR_UPSPRNTLBL_ERR_1017':
            // Missing Tracking ID Error
            return {
                type: 'TEMPORARY',
                retryable: error.retryable,
            };
        default:
            // Unknown Error
            return {
                type: 'UNKNOWN',
                retryable: error.retryable,
            };
    }
};
